import { Component, OnInit } from '@angular/core';
import getAndParseUserPermissions from 'src/app/helpers/parsePermissions';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  // Still need to inherit localStorageService for getAndParseUserPermissions to work.
  constructor(private localStorageService: LocalstorageService) { }

  userPermissions;

  ngOnInit(): void {
    this.userPermissions = getAndParseUserPermissions(this.localStorageService)
  }
}
